import { fetchPaymentLinks } from '@api/payment-links';
import { handleQueryError } from '@basqet-dashboard/common/utils';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

const useFetchPaymentLinks = () => {
  const [paymentLinks, setPaymentLinks] = useState([]);
  const { isLoading, isError, isRefetching, data, error, refetch } = useQuery(
    'allPaymentLinks',
    fetchPaymentLinks
  );
  if (isError) {
    handleQueryError(error, 'payment links');
  }

  useEffect(() => {
    if (data && data.data) {
      setPaymentLinks(data.data);
    } else {
      setPaymentLinks([]);
    }
  }, [data]);
  return {
    isLoading,
    paymentLinks,
    isRefetching,
    refetch
  };
};

export { useFetchPaymentLinks };
